import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { nextSibling, prevSibling } from '../layout/mobileNavGroups';

// Edge-swipe навигация между соседними страницами группы меню.
// Жест начинается в 20px от левого или правого края экрана — так он не
// конфликтует ни с горизонтальным скроллом таблиц, ни с pull-to-refresh.

const EDGE_WIDTH = 20;      // px от края, где стартует жест
const MIN_DX = 60;          // px минимальный горизонтальный сдвиг
const MAX_DY = 40;          // px максимальный вертикальный (иначе это скролл)

export default function useEdgeSwipeNavigation(enabled: boolean): void {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return;

    let startX = 0;
    let startY = 0;
    let fromLeftEdge = false;
    let fromRightEdge = false;

    const onStart = (e: TouchEvent) => {
      const t = e.touches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      fromLeftEdge = startX < EDGE_WIDTH;
      fromRightEdge = startX > window.innerWidth - EDGE_WIDTH;
    };

    const onEnd = (e: TouchEvent) => {
      if (!fromLeftEdge && !fromRightEdge) return;
      const t = e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - startX;
      const dy = Math.abs(t.clientY - startY);
      if (dy > MAX_DY) return;
      if (Math.abs(dx) < MIN_DX) return;

      // Свайп вправо (от левого края внутрь) = назад (prev)
      // Свайп влево (от правого края внутрь) = вперёд (next)
      const target = dx > 0 && fromLeftEdge
        ? prevSibling(location.pathname)
        : dx < 0 && fromRightEdge
          ? nextSibling(location.pathname)
          : null;

      if (target && target !== location.pathname) {
        navigate(target);
      }
    };

    document.addEventListener('touchstart', onStart, { passive: true });
    document.addEventListener('touchend', onEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onStart);
      document.removeEventListener('touchend', onEnd);
    };
  }, [enabled, location.pathname, navigate]);
}
